import React, { Component } from 'react'
import { Card, List } from 'antd'
import { GridView } from 'models/GridView';

export class Information extends Component<{ contact : any, refreshKey?: number }> {
  state = {
    isLoading: false
  }
  getItemList = () : Array<GridView> => {
    if (!this.props.contact) return [];

    const fixedItems = [
      {
        title: 'Name:',
        description: this.props.contact.name
          ? this.props.contact.name
          : this.props.contact.identity.split('@')[0]
      },
      {
        title: 'Identity:',
        description: this.props.contact.identity
      },
      {
        title: 'E-mail:',
        description: this.props.contact.email
      },
      {
        title: 'Gender:',
        description: this.props.contact.gender
      },
      {
        title: 'Phone Number:',
        description: this.props.contact.phoneNumber
      },
      {
        title: 'City:',
        description: this.props.contact.city
      },
      {
        title: 'Source:',
        description: this.props.contact.source
      }
    ];

    const extras = Object.keys(this.props.contact.extras || []).reduce((prev, current) => {
      return [
        ...prev,
        { title: `Extras.${current}:`, description: this.props.contact.extras[current] }
      ]
    }, [])

    return [...fixedItems.filter(e => e.description), ...extras]
  }

  componentDidUpdate(prevProps: Readonly<{ ownerIdentity: string, contact: any, refreshKey?: number }>) {
    if (prevProps.refreshKey !== this.props.refreshKey) {
      this.setState({ isLoading: true });
      setTimeout(() => {
        this.setState({ isLoading: false })
      }, 500)
    }
  }
  render() {
    const { isLoading } = this.state;
    return (
      <Card title="Contact Info">
        <List loading={isLoading}
          dataSource={this.getItemList()}
          renderItem={item => (
            <List.Item key={item.title}>
              <List.Item.Meta title={item.title} description={item.description} />
            </List.Item>
          )}/>
      </Card>
    )
  }
}